<template>
    <mm-select :options="categoriesOptions"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>
<script>
export default {
	data(){
		const categoriesOptions = this.$cache.categories.map((v=>{return {label:v,value:v}}))
		return {
			categoriesOptions,
		}
	},
	props:{
		type:{
			type:String,
		},
		value:{},
	},
        
}
</script>
